import { c as _c } from "react/compiler-runtime";
import { CircleArrowDown02IconSolid } from '@/components/ui/icon/glyphs';
interface OgValueChangeProps {
  direction: 'up' | 'down';
  label: string;
  size?: number;
}

/** Satori-safe rendering of the catalog-backed circle-arrow icon. */
export function OgValueChange(t0) {
  const $ = _c(12);
  const {
    direction,
    label,
    size: t1
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  const t2 = Math.max(3, size / 4);
  let t3;
  if ($[0] !== t2) {
    t3 = {
      display: "flex",
      alignItems: "center",
      gap: t2
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = direction === "up" ? "rotate(180 12 12)" : undefined;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = CircleArrowDown02IconSolid.map(_temp);
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t4) {
    t6 = <g transform={t4}>{t5}</g>;
    $[3] = t4;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== size || $[6] !== t6) {
    t7 = <svg width={size} height={size} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>{t6}</svg>;
    $[5] = size;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== label || $[9] !== t3 || $[10] !== t7) {
    t8 = <span style={t3}>{t7}{label}</span>;
    $[8] = label;
    $[9] = t3;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  return t8;
}
function _temp(t0) {
  const [element, t1] = t0;
  const {
    key,
    ...attributes
  } = t1;
  return element === "path" ? <path key={key} {...attributes} /> : null;
}